import { createSlice } from "@reduxjs/toolkit";

const optionsSlice = createSlice({
  name: "options",
  initialState: {
    isLoading: false,
    mobileCodes: [],
    companyTypeOptions: [],
    businessTypeOptions: [],
    provinceOptions: [],
    districtOptions: [],
    subDistrictOptions: [],
    shiftConditionChangeOptions: [],
    otReqConditionOptions: [],
    breakPeriodTypeOptions: [],
    holidayTypeOptions: [],
    deviceTypeOptions: [],
    deductionByTypeOptions: [],
    incomeDeductionByTypeOptions: [],
    incomeByCompanyOptions: [],
    deductByCompanyOptions: [],
    roundingTypeOptions: [],
    employmentSetupOptions: [],
    frequencyOfPaymentOptions: [],
    taxCalculationOptions: [],
    reasonForSSOOptions: [],
    employeeTypeOptions: [],
    titleNameOptions: [],
    titleNameEnOptions: [],
    welfareTypeOptions: [],
    rolePermissionOptions: [],
    periodTimeUnitOptions: [],
    genderOptions: [],
    welfareLimitOptions: [],
    attendanceConditionOptions: [],
    weekDayWorkingOptions: [],
    weekWorkingOptions: [],
    socialSecurityBranchOption: [],
    accountTypeOption: [],
    welfarePaidOptions: [],
    typeOfSlipOptions: [],
    leaveGroupOptions: [],
    leaveRequestConditionOptions: [],
    monthWeekDayWorkingOptions: [],
    leaveCalculationOptions: [],
    amountIncomeDeductionOptions: [],
    raceOptions: [],
    nationalityOptions: [],
    religionOptions: [],
    maritalStatusOptions: [],
    militaryStatusOptions: [],
    bloodGroupOptions: [],
    relationshipOptions: [],
    employeeStatusTypeOptions: [],
    employmentTypeOptions: [],
    educationDegreeOptions: [],
    bankOptions: []
  },
  reducers: {
    setIsLoading(state, action) {
      state.isLoading = action.payload;
    },
    setMobileCodes(state, action) {
      state.mobileCodes = action.payload;
    },
    setCompanyTypeOptions(state, action) {
      state.companyTypeOptions = action.payload;
    },
    setBusinessTypeOptions(state, action) {
      state.businessTypeOptions = action.payload;
    },
    setProvinceOptions(state, action) {
      state.provinceOptions = action.payload;
    },
    setDistrictOptions(state, action) {
      state.districtOptions = action.payload;
    },
    setSubDistrictOptions(state, action) {
      state.subDistrictOptions = action.payload;
    },
    setRegisteredProvinceOptions(state, action) {
      state.registered_provinceOptions = action.payload;
    },
    setRegisteredDistrictOptions(state, action) {
      state.registered_districtOptions = action.payload;
    },
    setRegisteredSubDistrictOptions(state, action) {
      state.registered_subDistrictOptions = action.payload;
    },
    setShiftConditionChangeOptions(state, action) {
      state.shiftConditionChangeOptions = action.payload;
    },
    setOtReqConditionOptions(state, action) {
      state.otReqConditionOptions = action.payload;
    },
    setBreakPeriodTypeOptions(state, action) {
      state.breakPeriodTypeOptions = action.payload;
    },
    setHolidayTypeOptions(state, action) {
      state.holidayTypeOptions = action.payload;
    },
    setDeviceTypeOptions(state, action) {
      state.deviceTypeOptions = action.payload;
    },
    setDeductionByTypeOptions(state, action) {
      state.deductionByTypeOptions = action.payload;
    },
    setIncomeDeductionByTypeOptions(state, action) {
      state.incomeDeductionByTypeOptions = action.payload;
    },
    setIncomeByCompanyOptions(state, action) {
      state.incomeByCompanyOptions = action.payload;
    },
    setDeductByCompanyOptions(state, action) {
      state.deductByCompanyOptions = action.payload;
    },
    setRoundingTypeOptions(state, action) {
      state.roundingTypeOptions = action.payload;
    },
    setEmploymentSetupOptions(state, action) {
      state.employmentSetupOptions = action.payload;
    },
    setFrequencyOfPaymentOptions(state, action) {
      state.frequencyOfPaymentOptions = action.payload;
    },
    setTaxCalculationOptions(state, action) {
      state.taxCalculationOptions = action.payload;
    },
    setReasonForSSOOptions(state, action) {
      state.reasonForSSOOptions = action.payload;
    },
    setEmployeeTypeOptions(state, action) {
      state.employeeTypeOptions = action.payload;
    },
    setTitleNameOptions(state, action) {
      state.titleNameOptions = action.payload;
    },
    setTitleNameEnOptions(state, action) {
      state.titleNameEnOptions = action.payload;
    },
    setWelfareTypeOptions(state, action) {
      state.welfareTypeOptions = action.payload;
    },
    setRolePermission(state, action) {
      state.rolePermissionOptions = action.payload;
    },
    setPeriodTimeUnitOptions(state, action) {
      state.periodTimeUnitOptions = action.payload;
    },
    setGenderOptions(state, action) {
      state.genderOptions = action.payload;
    },
    setWelfareLimitOptions(state, action) {
      state.welfareLimitOptions = action.payload;
    },
    setAttendanceConditionOptions(state, action) {
      state.attendanceConditionOptions = action.payload;
    },
    setWeekDayWorkingOptions(state, action) {
      state.weekDayWorkingOptions = action.payload;
    },
    setWeekWorkingOptions(state, action) {
      state.weekWorkingOptions = action.payload;
    },
    setSocialSecurityBranchOption(state, action) {
      state.socialSecurityBranchOption = action.payload;
    },
    setAcountTypeOption(state, action) {
      state.accountTypeOption = action.payload;
    },
    setWelfarePaidOptions(state, action) {
      state.welfarePaidOptions = action.payload;
    },
    setTypeOfSlipOptions(state, action) {
      state.typeOfSlipOptions = action.payload;
    },
    setLeaveGroupOptions(state, action) {
      state.leaveGroupOptions = action.payload;
    },
    setLeaveRequestConditionOptions(state, action) {
      state.leaveRequestConditionOptions = action.payload;
    },
    setMonthWeekDayWorkingOptions(state, action) {
      state.monthWeekDayWorkingOptions = action.payload;
    },
    setLeaveCalculationOptions(state, action) {
      state.leaveCalculationOptions = action.payload;
    },
    setAmountIncomeDeductionOptions(state, action) {
      state.amountIncomeDeductionOptions = action.payload;
    },
    setRaceOptions(state, action) {
      state.raceOptions = action.payload;
    },
    setNationalityOptions(state, action) {
      state.nationalityOptions = action.payload;
    },
    setReligionOptions(state, action) {
      state.religionOptions = action.payload;
    },
    setMaritalStatusOptions(state, action) {
      state.maritalStatusOptions = action.payload;
    },
    setMilitaryStatusOptions(state, action) {
      state.militaryStatusOptions = action.payload;
    },
    setBloodGroupOptions(state, action) {
      state.bloodGroupOptions = action.payload;
    },
    setRelationshipOptions(state, action) {
      state.relationshipOptions = action.payload;
    },
    setEmployeeStatusTypeOptions(state, action) {
      state.employeeStatusTypeOptions = action.payload;
    },
    setEmploymentTypeOptions(state, action) {
      state.employmentTypeOptions = action.payload;
    },
    setEducationDegreeOptions(state, action) {
      state.educationDegreeOptions = action.payload;
    },
    setBankOptions(state, action) {
      state.bankOptions = action.payload;
    }
  },
},
);

export const {
  setIsLoading,
  setMobileCodes,
  setCompanyTypeOptions,
  setBusinessTypeOptions,
  setProvinceOptions,
  setDistrictOptions,
  setSubDistrictOptions,
  setRegisteredProvinceOptions,
  setRegisteredDistrictOptions,
  setRegisteredSubDistrictOptions,
  setShiftConditionChangeOptions,
  setOtReqConditionOptions,
  setBreakPeriodTypeOptions,
  setHolidayTypeOptions,
  setDeviceTypeOptions,
  setIncomeDeductionByTypeOptions,
  setIncomeByCompanyOptions,
  setDeductByCompanyOptions,
  setRoundingTypeOptions,
  setEmploymentSetupOptions,
  setFrequencyOfPaymentOptions,
  setTaxCalculationOptions,
  setReasonForSSOOptions,
  setEmployeeTypeOptions,
  setTitleNameOptions,
  setTitleNameEnOptions,
  setWelfareTypeOptions,
  setRolePermission,
  setPeriodTimeUnitOptions,
  setGenderOptions,
  setWelfareLimitOptions,
  setAttendanceConditionOptions,
  setWeekDayWorkingOptions,
  setWeekWorkingOptions,
  setSocialSecurityBranchOption,
  setAcountTypeOption,
  setWelfarePaidOptions,
  setTypeOfSlipOptions,
  setLeaveGroupOptions,
  setLeaveRequestConditionOptions,
  setMonthWeekDayWorkingOptions,
  setLeaveCalculationOptions,
  setAmountIncomeDeductionOptions,
  setRaceOptions,
  setNationalityOptions,
  setReligionOptions,
  setMaritalStatusOptions,
  setMilitaryStatusOptions,
  setBloodGroupOptions,
  setRelationshipOptions,
  setEmployeeStatusTypeOptions,
  setEmploymentTypeOptions,
  setEducationDegreeOptions,
  setBankOptions
} = optionsSlice.actions;
export default optionsSlice.reducer;
